import React from 'react';
import './CallAnalysisFeatureCommonComponent.css';
import { Grid, Typography } from '@mui/material';
import chronox_featurelogo from "../../assests/Pages/CallAnalysis/chronox_featurelogo.png";

const CallAnalysisFeatureCommonComponent = ({ format }) => {
  return (
    <Grid container className="call-analysis-main-container" justifyContent={"center"} alignItems={"center"} >
      <Grid item xs={12} sm={12} lg={10.7} xl={10} className="call-analysis-inner-wrapper">
        <Grid container direction="column" alignItems="center" gap={6}>
          <Grid item className="ca_feature_title_wrapper">
            <h3 className="call-analysis-title">Features for Call Analysis</h3>
          </Grid>

          <Grid item>
            <Grid container spacing={3} justifyContent="center">
              {format.featureCallAnalysisData.map((item) => (
                <Grid item className="custom-width" key={item.f_ca_id} justifyContent={"center"} display={"flex"}> 
                  <Grid container className={`feature-card ${item.f_ca_id % 2 !== 0 ? 'dark-card' : 'light-card'}`}>
                    <img src={chronox_featurelogo} alt="bg-logo" className="feature-card-bg-logo" />

                    <Grid item xs={12} >
                      <img src={item.f_ca_img} alt={item.f_ca_heading} />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container gap={2}>
                          <Grid item>
                            <Typography variant='h4' className="feature-title">{item.f_ca_heading}</Typography>
                          </Grid>
                          <Grid>
                            <Typography className="feature-desc">{item.f_ca_detail}</Typography>
                          </Grid>
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CallAnalysisFeatureCommonComponent;
